import { EditorElementInterfaceBeta } from "../../../../../../../ducks/types";

export enum ContextualRecomParamName {
    H1 = "h1",
    H2 = "h2",
    H3 = "h3",
    META_DESCRIPTION = "meta_description",
    TITLE = "title",
    URL = "url",
    STRIPPED_PAGE = "stripped_page"
}

export interface ContextualRecommendationsModalBodyPropsInterface {
    parameterName: ContextualRecomParamName;
    contextText: string | string[];
    highlightingTokens: string[];
    visibleContent?: EditorElementInterfaceBeta[];
    elementKey?: string;
    initialRecommendations?: ElementRecommendationsInterface;
    onRecommendationsUpdate?: (recommendations: ElementRecommendationsInterface) => void;
    onCloseHandler(): void;
    onUpdateContentHandler(args: string[]): void;
}

export interface ElementRecommendationsInterface {
    keywordFocus: ContextualRecommendationsInterface[];
    serpDriven: ContextualRecommendationsInterface[];
    competitorDriven: ContextualRecommendationsInterface[];
}
export interface ContextKeywordsInterface {
    [id: string]: boolean;
}

export interface ContextualRecommendationAPIInterface {
    keywords: string[];
    context: string[];
    element: string;
    tenant_code: string;
}

export interface ContextualRecommendationsModalRightPanelPropsInterface {
    parameterName: ContextualRecomParamName;
    isGenerateBtnClicked: boolean;
    elemnetText: string;
    checkboxStatus: boolean[];
    localRecommendations?: ElementRecommendationsInterface;
    onAddToEditorClick(selectedTab?: ContextualRecommendationType): void;
    onChangeHandlerFunction(index: number): void;
    isAddToEditorButtonDisable(): boolean;
}

export interface ContextualRecomModalLeftPanelPropsInterface {
    parameterName: ContextualRecomParamName;
    contextText: string | string[];
    visibleContent?: EditorElementInterfaceBeta[];
    highlightingTokens: string[];
    elementKey?: string;
    setIsGenerateBtnClicked(args: boolean): void;
    callSelectedTargetKeyword(args: { [id: string]: boolean }): void;
}

export interface ContextualRecommEditSectionInterface {
    contents: string;
    parameterName: ContextualRecomParamName;
    updateContextValue(args: string): void;
}

export interface ContextualRecommendationsAddKwdInterface {
    keywordDict: { [id: string]: boolean };
    toggleKeywordHandler(args: string): void;
}

export interface ContextualRecommendationsInterface {
    recommendation: string;
    char_count: number;
    score: number;
}

export enum ContextualRecommendationType {
    KEYWORD_FOCUS = "Keyword Focus",
    SERP_DRIVEN = "SERP-Driven",
    COMPETITOR_DRIVEN = "Competitor-Driven"
}

export enum ContextualRecommendationTypeInfo {
    KEYWORD_FOCUS = "SEO copy optimized using target keywords and inputs.",
    SERP_DRIVEN = "Inspired by top 10 search results for your keywords.",
    COMPETITOR_DRIVEN = "Uses competitor insights to guide tone, benefits, and positioning."
}

export interface ExtractedHeaders {
    H1: string[];
    H2: string[];
    H3: string[];
}

export interface ContentElements {
    Title: string[];
    "Meta Description": string[];
    H1: string[];
    H2: string[];
    H3: string[];
    URL: string[];
}

export interface ContextualRecommendationsReducerInterface {
    contextualRecommendations: ContextualRecommendationsInterface[];
    isContextRecomModalOpen: boolean;
    isContextualRecomLoding: boolean;
    isContextualApiFail?: boolean;
    contextualRecommendationsSerp: ContextualRecommendationsInterface[];
    contextualRecommendationsBusiComp: ContextualRecommendationsInterface[];
    isContextualRecomSerpLoding: boolean;
    isContextualRecomBusiCompLoding: boolean;
    isContextualRecomScoreLoding: boolean;
    isContextualRecomSerpScoreLoding: boolean;
    isContextualRecomBusiCompScoreLoding: boolean;
    currentElementKey?: string;
}
export interface ContextRecommendationSseEventInterface {
    receive_recommendations: string;
    receive_recommendation_score: string;
    receive_recommendations_busi_comp: string;
    receive_recommendation_score_busi_comp: string;
    receive_recommendations_serp: string;
    receive_recommendation_score_serp: string;
    req_completed: string;
    req_failed: string;
    error: string;
}

export interface ContextualRecommendationsInterface {
    recommendation: string;
    char_count: number;
    score: number;
}
